import decode from 'jwt-decode';
import { browserHistory } from 'react-router-dom';
import auth0 from 'auth0-js';
import createBrowserHistory from "../components/history";
const ID_TOKEN_KEY = 'id_token';
const ACCESS_TOKEN_KEY = 'access_token';

//test
// const CLIENT_ID = '6YyebbjFh8K4d8T1n5lQr7pp7EMe3Qaj';
// const CLIENT_DOMAIN = 'lichwa-test.eu.auth0.com';
// const REDIRECT = 'http://localhost:3000/callback';
// const SCOPE = 'openid profile email phone';
// const AUDIENCE = 'http://chucknorrisworld.com';

//prod
const CLIENT_ID = 'AsAZ2EQPyrC3jzafRmq361zJvT0xoQ5Z';
const CLIENT_DOMAIN = 'uslugi-ramiarskie.eu.auth0.com';
const REDIRECT = 'http://217.182.200.222:3000/callback';
const SCOPE = 'openid profile email phone';
const AUDIENCE = 'http://217.182.200.222:3000';


  let userProfile;
  let userMail;

  var usersAdmin = ['maciej.lichwa@gmail.com','jerzyczupik@wp.pl','abulat.projekty@gmail.com']
  var usersMagazyn = ['legocka@op.pl','aszczescie@gmail.com']
  var usersSprzedawca = ['domka.godz@gmail.com','aleksandra.kos.94@gmail.com', 'kylesovinsky@gmail.com', 'dominikaostankowicz@gmail.com']

  function contains(a, obj) {


      for (var i = 0; i < a.length; i++) {
          if (a[i] === obj) {
                console.log('true '+ obj);
              return true;
          }
      }
      return false;
  }

  var auth = new auth0.WebAuth({
    clientID: CLIENT_ID,
    domain: CLIENT_DOMAIN,
    scope: 'openid profile email phone'
  });

  export function login() {
    auth.authorize({
      responseType: 'token id_token',
      redirectUri: REDIRECT,
      audience: AUDIENCE,
      scope: SCOPE
    });
  }
  export function ifMagazyn(){
    prepareMail();
    return contains(usersMagazyn,userMail);
  }

  export function ifAdmin(){
    prepareMail();
    return contains(usersAdmin,userMail);
  }

  export function ifSprzedawca(){
    prepareMail();
    return contains(usersSprzedawca,userMail);
  }

export function contains(a, obj) {
    for (var i = 0; i < a.length; i++) {
        if (a[i] === obj) {
            return true;
        }
    }
    return false;
}

  export function prepareMail() {
    const mail = getEmail((mail) => {

      // for (var i = 0; i < usersStorage.length; i++) {
      //     if (usersStorage[i] === mail) {
      //           console.log('true '+ mail);
      //           userMail=mail;
      //         return mail;//true;
      //     }
      // }
      userMail=mail;
      return mail;
    });




    // let accessToken = getAccessToken();
    // //console.log(auth)
    // auth.client.userInfo(accessToken, (err, profile)=>{
    //   if (profile) {
    //     //console.log(profile)
    //     userProfile = profile;
    //     console.log(222222+userProfile.email)
    //     return userProfile.email ==='maciej.lichwa@gmail.com';
    //   }
    // })
 }

export function getProfile(cb) {
  let accessToken = getAccessToken();
  auth.client.userInfo(accessToken, (err, profile)=>{
    if (profile) {
      userProfile = profile;
      cb(userProfile.email);
    }
  })}

  export function getEmail(cb) {
    userProfile = getProfile((mail) => {
      cb(mail);
    });
    }

  export function logout() {
    clearIdToken();
    clearAccessToken();
    createBrowserHistory.push('/');
  }

  export function requireAuth(nextState, replace) {
    if (!isLoggedIn()) {
      replace({pathname: '/'});
    }
  }

  export function getIdToken() {
    return localStorage.getItem(ID_TOKEN_KEY);

  }

  export function getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  function clearIdToken() {
    localStorage.removeItem(ID_TOKEN_KEY);
  }

  function clearAccessToken() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  }

  // Helper function that will allow us to extract the access_token and id_token
  function getParameterByName(name) {
    let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  // Get and store access_token in local storage
  export function setAccessToken() {
    let accessToken = getParameterByName('access_token');
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  }

  // Get and store id_token in local storage
  export function setIdToken() {
    let idToken = getParameterByName('id_token');
    localStorage.setItem(ID_TOKEN_KEY, idToken);
  }

  export function isLoggedIn() {
    const idToken = getIdToken();
    if (idToken == null) return false;
    return !!idToken && !isTokenExpired(idToken);
  }

  function getTokenExpirationDate(encodedToken) {
    const token = decode(encodedToken);
    if (!token.exp) { return null; }

    const date = new Date(0);
    date.setUTCSeconds(token.exp);

    return date;
  }

  function isTokenExpired(token) {
    const expirationDate = getTokenExpirationDate(token);
    return expirationDate < new Date();
  }



// WEBPACK FOOTER //
// ./src/utils/AuthService.js